import React from 'react';
import { Card, Row, Col, Form, Button, Input } from 'antd';
import styles from './spanish-login.module.css';

const SpanishLogin = ({ onFinish, error, form, languageButtons }) => {
  return (
    <div className={styles.card_container}>
      <Card className={styles.login_card} bodyStyle={{ padding: 0 }}>
        <Row>
          <Col xs={24} className={styles.card_header_wrapper}>
            Te damos la bienvenida a BRAVE UP!
            <br />
            Por favor ingresa tus datos para iniciar sesión
          </Col>
          {error && error?.message ? (
            <Col xs={24} className={styles.card_error_wrapper}>
              <span>{error?.message}</span>
            </Col>
          ) : null}
          <Col xs={24} className={styles.card_form_wrapper}>
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Form.Item
                label="Correo electrónico"
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Email requerido',
                  },
                  {
                    required: true,
                    type: 'email',
                    message: 'El email no es válido',
                  },
                ]}
              >
                <Input size="large" placeholder="email@email.com" />
              </Form.Item>
              <Form.Item
                label="Contraseña"
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Contraseña requerida',
                  },
                ]}
              >
                <Input.Password size="large" placeholder="*********" />
              </Form.Item>
              <Form.Item shouldUpdate>
                {() => (
                  <Button
                    type="primary"
                    block
                    style={{ borderRadius: '0px' }}
                    size="large"
                    ghost
                    htmlType="submit"
                    disabled={
                      form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    Iniciar sesión
                  </Button>
                )}
              </Form.Item>
            </Form>
          </Col>
          {/* <Col xs={24} className="card-header-wrapper">
              <Button
                type="primary"
                ghost={true}
                block={true}
                size="large"
                style={{ display: 'flex', justifyContent: 'center' }}
                onClick={singInWhitGoogle}
              >
                <GoogleIcon
                  style={{ width: 24, height: 24, marginLeft: -10, marginRight: 10 }}
                />
                Ingresar con Google
              </Button>
            </Col> */}
          <Col
            xs={24}
            className={
              (styles.card_header_wrapper, styles.password_reset_wrapper)
            }
          >
            <a href="/password-reset">¿Has olvidado tu contraseña?</a>
          </Col>
          {languageButtons}
        </Row>
      </Card>
    </div>
  );
};

export default SpanishLogin;
